/**
 * Возвращает объект, где для каждого воркспейса, у которого есть виджеты выдает количество этих виджетов
 * @param appJSON
 */
let getWorkspaceWidgetCount = (appJSON) => {
    let workspaces = {};

    appJSON.widgets.widgets.forEach((widget) => {
        if (typeof workspaces[widget.workspace] === 'undefined') {
            workspaces[widget.workspace] = 0;
        }

        workspaces[widget.workspace]++;
    });

    return workspaces;
};

export { getWorkspaceWidgetCount };
